import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { createAppThunk, type IRes } from "store/modules/common";
import Http from "commons/Http";

// 이름 설정
const name = "signup";

export interface ISignup {
  phone: {
    id?: string;
    num?: string;
    token?: string;
    verifyFlag: boolean;
    sendNumberFlag: boolean;
    isLoading?: boolean;
  };
}

// 핸드폰 인증번호 요청
export const apiPsendAuthNumber = createAppThunk<{ id: string }, string>(
  `${name}/apiPsendAuthNumber`,
  async (param, thunkApi) => {
    const res = await Http.post<IRes<{ id: string }>>("auth/phone", { phone: param });
    if (res.data.content) {
      thunkApi.dispatch(rdxSetPhoneIdValue({ id: res.data.content.id, phone: param }));
    }
    return res.data;
  },
);

// 핸드폰 인증번호 확인 api
export const apiPConfirmPhoneNumCheck = createAppThunk<{ result: boolean; phone_token: string }, string>(
  `${name}/apiPConfirmPhoneNumCheck`,
  async (param, thunkApi) => {
    const res = await Http.post<IRes<{ result: boolean; phone_token: string }>>("auth/phone/verify", {
      id: thunkApi.getState().signup.phone.id,
      code: param,
    });

    if (res.data.content) {
      thunkApi.dispatch(rdxSetPhoneToken(res.data.content.phone_token));
    }
    return res.data;
  },
);

// 이메일 회원가입
export const apiPemailSignUp = createAppThunk(`${name}/apiPemailSignUp`, async (_, thunkApi) => {
  const res = await Http.post("user/signUp", {
    phone_token: thunkApi.getState().signup.phone.token,
    email: thunkApi.getState().ui.inputText?.["signupEmail"]?.trim(),
    password: thunkApi.getState().ui.inputText?.["signupPasswd"]?.trim(),
    name: thunkApi.getState().ui.inputText?.["signupName"]?.trim(),
  });

  return res.data;
});

// 카카오 회원가입
export const apiPkakaoSignUp = createAppThunk(`${name}/apiPkakaoSignUp`, async (_, thunkApi) => {
  const res = await Http.post("user/signUp/kakao", {
    token: thunkApi.getState().auth.kakao.token,
    phone_token: thunkApi.getState().signup.phone.token,
    name: thunkApi.getState().ui.inputText?.["signupName"]?.trim(),
  });

  return res.data;
});

const signupSlice = createSlice({
  name,
  initialState: {
    phone: {
      verifyFlag: false,
      sendNumberFlag: false,
    },
  } as ISignup,
  reducers: {
    //인증번호 요청할때 오는 응닶값 id 저장
    rdxSetPhoneIdValue(state: ISignup, action: PayloadAction<{ id: string; phone: string }>) {
      state.phone.id = action.payload.id;
      state.phone.num = action.payload.phone;
    },
    //휴대폰 인증 후 토큰 값 저장
    rdxSetPhoneToken(state: ISignup, action: PayloadAction<string>) {
      state.phone.token = action.payload;
    },

    //인증번호요청 클릭 했는지 안했는지 여부
    rdxSetPhoneSendNumber(state: ISignup, action: PayloadAction<boolean>) {
      state.phone.sendNumberFlag = action.payload;
    },
    //휴대폰 인증 했는지 안했는지 여부
    rdxSetPhoneVerify(state: ISignup, action: PayloadAction<boolean>) {
      state.phone.verifyFlag = action.payload;
    },

    //핸드폰 인증 정보 초기화
    rdxResetPhoneInfo(state: ISignup) {
      delete state.phone.id;
      delete state.phone.token;
      delete state.phone.num;
      delete state.phone.isLoading;
      state.phone.sendNumberFlag = false;
      state.phone.verifyFlag = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(apiPsendAuthNumber.pending, state => {
      state.phone.isLoading = true;
    });
    builder.addCase(apiPsendAuthNumber.fulfilled, state => {
      state.phone.isLoading = false;
    });
  },
});

export const { rdxSetPhoneIdValue, rdxSetPhoneToken, rdxSetPhoneSendNumber, rdxSetPhoneVerify, rdxResetPhoneInfo } =
  signupSlice.actions;

export default signupSlice.reducer;
